import * as React from "react";
import * as SRD from "@projectstorm/react-diagrams";
import {BaseWidget} from "../BaseWidget/BaseWidget";
import {ActionNodeModel} from "../../../../model/workflowEditor";

type ActionWidgetProps = {
  engine: SRD.DiagramEngine;
  node: ActionNodeModel;
};

const ActionWidget: React.FunctionComponent<ActionWidgetProps> = ({
  engine,
  node,
}) => {
  return (
    <>
      <BaseWidget node={node} engine={engine} backgroundColor='#d231ec'>
      {node.data.messages[0]}
      </BaseWidget>
    </>
  );
};

export default ActionWidget;